import { combineReducers } from 'redux'
import { containerPosition } from 'components/categoryMenu/reducer'
import { activeCategory } from 'components/hotelCategory/reducer'
import { sidebar } from 'components/slidingpane/reducer'

const hotelRatingState = combineReducers({
  containerPosition,
  activeCategory,
  sidebar
})

export default hotelRatingState



// WEBPACK FOOTER //
// ./src/stores/index.js